/* Homepage-only document prefetch. Navigation stays native for Shopify and apps. */
(() => {
  if (window.Shopify?.designMode) return;
  const canPrefetch = () => {
    const connection = navigator.connection;
    return navigator.onLine !== false && !connection?.saveData &&
      !['slow-2g', '2g'].includes(connection?.effectiveType);
  };
  function prepareProducts() {
    if (!canPrefetch() || document.visibilityState !== 'visible') return;
    const urls = new Set();
    // Prioritise the main shop destination; derive URLs from actual theme links.
    const links = [document.querySelector('.n-mix-cta'), ...document.querySelectorAll('a[href]')];
    for (const link of links) {
      if (!link || link.hasAttribute('download')) continue;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) continue;
      // Ignore action/tracking URLs. Keep a selected variant if explicitly linked.
      if ([...url.searchParams.keys()].some(key => key !== 'variant')) continue;
      url.hash = '';
      urls.add(url.href);
      if (urls.size === 3) break;
    }
    if (!urls.size) return;
    if (window.HTMLScriptElement?.supports?.('speculationrules')) {
      const rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.dataset.gProductPrefetch = '';
      rules.textContent = JSON.stringify({prefetch: [{source: 'list', urls: [...urls], eagerness: 'immediate'}]});
      document.head.append(rules);
    } else {
      for (const href of urls) {
        const link = document.createElement('link');
        link.rel = 'prefetch'; link.href = href; link.as = 'document';
        link.setAttribute('fetchpriority', 'low');
        link.dataset.gProductPrefetch = '';
        document.head.append(link);
      }
    }
  }
  function schedule() {
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', function visible() {
        if (document.visibilityState !== 'visible') return;
        document.removeEventListener('visibilitychange', visible);
        schedule();
      });
      return;
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(prepareProducts, {timeout: 2500});
    else setTimeout(prepareProducts, 200);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, {once: true});
})();
